import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import Head from "next/head";
import AppbarIndustry from "../../../../components/AppbarIndustry";
import HeroSection from "../../../../components/HeroSection";
import TitleIndustry from "../../../../components/TitleIndustry";
import HeroEnquiryFormIndustry from "../../../../components/HeroEnquiryFormIndustry";
import FooterIndustry from "../../../../components/FooterIndustry";
import { ourProducts } from "../../../../components/technology/data";
import StickyWhatsappIndustries from "../../../../components/StickyWhatsappIndustries";

function PlanningSoftware() {
  const products = [
    "Augmented Reality (AR) Development Kits",
  

  ];
  const data = {
    image: "/industries/technology/augmented-reality-ar-development-kits.avif", // Replace with the appropriate image URL
    intro: `Introducing our Augmented Reality (AR) Development Kits, emphasizing their role in enabling the creation of immersive and interactive augmented reality experiences.`,
    keyFeatures: [
      {
        title: "AR content creation tools and frameworks",
        content: "Empower developers with tools and frameworks for creating captivating AR content.",
      },
      {
        title: "Markerless and marker-based AR tracking",
        content: "Support both markerless and marker-based AR tracking for diverse applications.",
      },
      {
        title: "Integration with device sensors",
        content: "Integrate seamlessly with device sensors such as cameras and accelerometers for enhanced AR experiences.",
      },
      {
        title: "Real-time rendering and visualization",
        content: "Enable real-time rendering and visualization for a dynamic and responsive AR environment.",
      },
      {
        title: "Cross-platform compatibility",
        content: "Ensure cross-platform compatibility for broad accessibility and reach.",
      },
    ],
    howItWorks: `Explore how our AR Development Kits empower developers to build AR applications by providing essential tools and functionalities for AR content creation and deployment.`,
    benefits: {
      title: "The benefits of AR Development Kits",
      data: [
        "Creation of engaging and interactive AR experiences.",
        "Seamless integration with mobile and wearable devices.",
        "Real-time tracking for accurate AR object placement.",
        "Cross-platform development for broader audience reach.",
      ],
    },
    industries: "Highlight the relevance of AR Development Kits across industries, including education, gaming, retail, and manufacturing, where AR enhances user experiences and provides valuable insights.",
    stories: `Share success stories of organizations that have leveraged AR Development Kits to create innovative AR applications, driving user engagement and business success.`,
    contactUs: `Provide contact information for inquiries and support related to AR Development Kits.`,
    futureDevelopments: `Discuss upcoming features and innovations in AR technology, showcasing a commitment to staying at the forefront of immersive experiences.`,
    technology: `Detail how the development kits seamlessly integrate with various devices, sensors, and platforms, ensuring a versatile AR development environment.`,
    support: `Offer resources and support channels for developers to effectively utilize AR Development Kits in creating compelling augmented reality applications.`,
    industry: `Explain how the development kits adhere to industry standards, ensuring compatibility and security in AR application development.`,
    events: `Keep users informed about industry events and potential collaborations in the realm of augmented reality development.`,
    blog: `Provide a platform for articles, case studies, and expert insights in our AR Development Kits blog and knowledge hub dedicated to best practices in AR development.`,
    careers: `Invite individuals to explore career opportunities contributing to the development and implementation of Augmented Reality Development Kits. Join us in shaping the future of immersive digital experiences.`,
  };
  
  
  
  
  
  
  
  
  
  const content = "Embark on a technological evolution with us! Whether you're delving into cutting-edge technology, innovation in software development, user experience optimization, or any facet of the tech industry, we offer tailored solutions. Our expertise spans projects of various scales, ensuring our technology solutions align seamlessly with your goals, budget, and scope."
    return (
    <>
   <Head>
    <title>Augmented Reality (AR) Development Kits | Innovate with Techbrain Networks</title>
    <meta name="description" content="Innovate with Techbrain Networks Augmented Reality (AR) Development Kits, providing tools and resources for creating immersive AR experiences and applications." />
    <meta name="keywords" content="AR development kits, augmented reality, immersive experiences, Techbrain Networks" />
    <meta property="og:title" content="Augmented Reality (AR) Development Kits | Innovate with Techbrain Networks" />
    <meta property="og:description" content="Techbrain Networks Augmented Reality (AR) Development Kits offer tools and resources for creating immersive AR experiences and applications, driving innovation in AR technology." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.techbrainnetworks.com/industries/technology/products/augmented-reality-ar-development-kits" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="Augmented Reality (AR) Development Kits" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Augmented Reality (AR) Development Kits | Innovate with Techbrain Networks" />
    <meta name="twitter:description" content="Create immersive AR experiences with Techbrain Networks Augmented Reality (AR) Development Kits, providing advanced tools and resources for AR application development." />
     <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpgg" />
    <link rel="canonical" href="https://www.techbrainnetworks.com/industries/technology/products/augmented-reality-ar-development-kits" />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Augmented Reality (AR) Development Kits",
        "image": "https://www.techbrainnetworks.com/logo-tbn.jpg",
        "description": "Innovate with Techbrain Networks Augmented Reality (AR) Development Kits, providing tools and resources for creating immersive AR experiences and applications.",
        "brand": "Techbrain Networks",
        "offers": {
            "@type": "Offer",
            "url": "https://www.techbrainnetworks.com/industries/technology/products/augmented-reality-ar-development-kits",
            "priceCurrency": "USD",
            "price": "Contact for pricing"
        }
    })}} />
 <link rel="icon" href="/favicon.png" />

</Head>
<StickyWhatsappIndustries link={"https://api.whatsapp.com/send?phone=918754906714"}  color={"#5F85DB"} />

      <AppbarIndustry title={"Technology"} homeLink={'/industries/technology'} link={'/industries/technology/products'} />
    <HeroSection img={'/industries/technology/augmented-reality-ar-development-kits.avif'}>
    Augmented Reality (AR) Development Kits




    </HeroSection>
      <Box
        sx={{
          px: [0, "1.2rem", "3.8rem", "3rem"],
          pb: [1, 1, 2, 2, 4],
          bgcolor: "#01040a",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {/* intro */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#01040a",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",

            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5F85DB"}>Introduction</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.intro}
          </Typography>
        </Box>
        {/* Key Features Unleashed */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#01040a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", ".5rem", "1.5rem", "1.5rem", "1rem"],
          }}
        >
          <TitleIndustry color={"#5F85DB"}>Key Features Unleashed</TitleIndustry>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: ["column", "row"],
              flexWrap: "wrap",
              justifyContent: [null, "space-between", "flex-start"],
              gap: ["2rem", "1rem", "2rem", "2rem", "2rem"],
            }}
          >
            {data.keyFeatures.map((i, k) => (
              <Box
                sx={{
                  display: "flex",
                  width: ["95%", "45%", "30%"],
                  flexDirection: "column",
                  gap: ["0.5rem", "0.5rem", "0.5rem", "0.5rem", "1rem"],
                }}
              >
                <Typography
                  sx={{
                    fontSize: [
                      "1.3rem",
                      "1.2rem",
                      "1.2rem",
                      "1.4rem",
                      "1.5rem",
                    ],
                    fontWeight: "bold",
                    color: "#5F85DB",
                  }}
                >
                  {i.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {i.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        {/* how it works */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#01040a",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5F85DB"}>How It Works?</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.howItWorks}
          </Typography>
        </Box>
        {/* benefits */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#01040a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", "1.5rem", ".5rem"],
          }}
        >
          <Stack
            direction={"column"}
            sx={{
              width: ["100%", "48%"],
            }}
          >
            <TitleIndustry color={"#5F85DB"}>Benefits</TitleIndustry>
            <Typography
              sx={{
                fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                color: "#fff",
              }}
            >
              {data.benefits.title}:
            </Typography>

            <Stack
              direction={"column"}
              sx={{
                gap: [1, 1, 2],
                mt: [3, 3, 4],
              }}
            >
              {data.benefits.data.map((i, k) => (
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {"•  "}
                  {i}
                </Typography>
              ))}
            </Stack>
          </Stack>

          <Box
            sx={{
              width: ["100%", "50%", "45%"],
              height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
              backgroundImage: `url(${data.image})`,
              backgroundposition: "center",
              backgroundSize: "cover",
              backgroundrepeat: "no-repeat",
              borderRadius: "16px",
            }}
          />
        </Stack>
  {/* Industries */}
  <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#01040a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5F85DB"}>Industries</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industries}
          </Typography>
        </Box>

         

        {/* Future Developments and Innovations*/}
 
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#01040a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5F85DB"}>Future Developments and Innovations</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
           Stay informed about upcoming features and innovations in electronic countermeasure planning technolog.

          </Typography>
        </Box>

        {/* Technology Integration */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#01040a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5F85DB"}>Technology Integration</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.technology}
          </Typography>
        </Box>

        {/* User Training and Support */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#01040a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5F85DB"}>User Training and Support</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.support}
          </Typography>
        </Box>

        {/*  Industry Standards and Compliance */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#01040a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5F85DB"}> Industry Standards and Compliance</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industry}
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
          
            display: "flex",
            gap: "1rem",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: ["2rem", "3rem", "3rem", "4rem"],
                fontWeight: "bold",
                color: "#5F85DB",
                textAlign: "center",
              }}
            >
              Contact
            </Typography>
          </Box>
          <Box
            sx={{
              width: [ "100%"],
              display: "flex",
              justifyContent: "center",
              padding:'1rem'
            }}
          >
            <HeroEnquiryFormIndustry color={"#5F85DB"} products={products} content={content}/>
          </Box>
        </Box>
      </Box>
      <FooterIndustry ourProducts={ourProducts} color={"#5F85DB"} bg={"#01040a"} />
    </>
  );
}

export default PlanningSoftware;
